import React from "react";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Channel, Topic } from "../../constants";
import { MessageBrokerUtils } from "../../utils";
import styled from "styled-components";

const SEOFooterWrapper = styled.div`
  font-size: 12px;
  font-family: var(--wrapper-font-condensed-medium);
  padding: 0.75rem 1.25rem;
  background-color: var(--theme-background);
  color: var(--primary-client-text-color);
  display: flex;
`;

const SEOFooter = ({ content = "" }) => {
  const [textContent, setTextContent] = useState(content);

  useEffect(() => {
    if (content !== textContent) {
      setTextContent(content);
    }
  }, [content]);

  useEffect(() => {
    const urlDataSub = MessageBrokerUtils.subscribe({
      channel: Channel.UI,
      topic: Topic.urlData,
      callback: urlData => {
        setTextContent(urlData?.seoFooter);
      }
    });

    return () => {
      urlDataSub?.unsubscribe();
    };
  }, []);

  if (!textContent || textContent === "") {
    return null;
  }

  return <SEOFooterWrapper>{textContent}</SEOFooterWrapper>;
};

SEOFooter.propTypes = {
  content: PropTypes.string
};

export default React.memo(SEOFooter);
